import { supabase } from '../supabase'

/** 거래처 전체 목록 (상호 가나다순) */
export async function fetchClients() {
  const { data, error } = await supabase.from('clients').select('*').order('name')
  if (error) {
    console.error('clients 조회:', error.message)
    return []
  }
  return data || []
}

/**
 * 문서 저장 시 거래처 자동 등록/갱신.
 * 빈 값은 보내지 않아 기존 정보를 지우지 않는다. 실패해도 문서 저장은 막지 않음.
 */
export async function upsertClient({ name, addr, tel, fax }) {
  const n = (name || '').trim()
  if (!n) return
  const row = { name: n }
  if (addr) row.addr = addr
  if (tel) row.tel = tel
  if (fax) row.fax = fax
  const { error } = await supabase.from('clients').upsert(row, { onConflict: 'name' })
  if (error) console.error('clients 자동 등록:', error.message)
}
